import React, { useEffect, useState, useMemo } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

// import components
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Loading from './Loading/Loading';

import AccessSetupMsg from './popup/AccessSetupMsg';
import DynamicMessage from './popup/DynamicMessage';
import SetupOnlineTrading from './SetupOnlineTrading';
import SetupDigitalBanking from './SetupDigitalBanking';
import SetupVerification from './SetupVerification';
import StatusMsg from './popup/StatusMsg';
import successLogo from '@/assets/images/success.png';
import failedLogo from '@/assets/images/failed.png';
import parse from "html-react-parser";

// only demo
// import SetUpOnLineDemo from './demo/SetUpOnlineDemo';

import {
  preventSpecialCharacters,
  restrictSpecialCharacters,
} from '../utils.ts';
import { saveFormData } from '../store/form';

const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    padding: '0 10px',
    paddingTop: '80px',
    minHeight: 'calc(100vh - 363px)',
    position: 'relative',
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '@media (max-width: 767px)': {
      padding: '30px 0 0',
    },
  },
  p0: {
    padding: '0 !important'
  },
  title: {
    fontSize: theme.typography.$fzH2,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '32px',
    letterSpacing: 'normal',
    marginBottom: '16px',
    color: theme.palette.$title,
  },
  setUpHeader: {
    width:'880px'
  },
  subTitle: {
    fontWeight: 400,
    fontSize: theme.typography.$fzH4,
    lineHeight: '28px',
    color: theme.palette.$lightTextGray,
    margin: '0 0'
  },
  mt40: {
    marginTop: '40px',
  },
  mt20: {
    marginTop: '20px',
  },
  buttonModal: {
    textAlign: 'right',
  },
  resentOtp: {
    fontSize: theme.typography.$fzH5,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.63',
    letterSpacing: 'normal',
    color: theme.palette.$clearBlue,
    marginTop: '5px',
  },
  headerModal: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '26px',
    '& img': {

    },
    '& span': {
      fontSize: theme.typography.$fzH2,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.42',
      letterSpacing: 'normal',
      marginLeft: '20px',
    },
  },
  headerModal2: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '26px',
    '& img': {

    },
    '& span': {
      fontSize: theme.typography.$fzH2,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.42',
      letterSpacing: 'normal',
    },
  },
  description: {
    fontSize: theme.typography.$fzH4,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '28px',
    letterSpacing: 'normal',
    color: theme.palette.$description,
    '@media (max-width: 767px)': {
      fontSize: theme.typography.$fzH6,
      '& br': {
        display: 'none',
      },
    },
  },
  ml20: {
    marginLeft: '20px',
  },
  dateComponent: {
    '& .MuiInputAdornment-positionEnd': {
      display: 'none',
    },
  },
  buttonWrapper: {
    // display: 'flex',
    position: 'absolute',
    bottom: 0,
    right: 0,
    textAlign: 'right',
    alignItems: 'center',
    margin: '0 auto',
    '@media (max-width: 767px)': {
      display: 'block',
    },
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '& Button': {
      minWidth: '118px',
      height: '52px'
    },
  },
  buttonWrapperSubmit: {
    textAlign: 'right',
    marginTop: '30px',
  },
  mb40: {
    marginBottom: '40px',
  },
  mt30: {
    marginBottom: '30px',
  },
  buttonSecondary: {
    marginLeft: '20px',
    '@media (max-width: 767px)': {
      width: '100%',
      marginTop: '20px',
      marginLeft: '0px',
      button: {
        width: '100%',
      },
    },
  },
  textBlur: {
    lineHeight: '1.71',
    fontSize: theme.typography.$fzDes,
    color: theme.palette.$inputColor,
    marginTop: '5px',
  },
  inputWrapper: {
    position: 'relative',
  },
  eyeIcon: {
    verticalAlign: "middle"
  },
  icon: {
    width: '24px',
    height: '24px',
    paddingRight: '8px',
    position: 'absolute',
    right: '0',
    top: '20px',
    cursor: 'pointer',
  },
  iconCodeInput: {
    position: 'absolute',
    top: '30px',
    right: '-10px',
    cursor: 'pointer',
  },
  message: {
    color: '#cb2d3e',
    fontSize: '0.75rem',
    marginTop: '-10px',
  },
  label: {
    fontSize: theme.typography.$fzH6,
    marginBottom: '10px',
  },
  mt5: {
    marginTop: '5px',
  },
  showText: {
    marginTop: '-10px',
  },
  mt10: {
    marginTop: '10px',
  },
  iconWarning: {
    verticalAlign: 'middle',
    marginBottom: '2px',
    marginRight: '4px',
  },
  right55: {
    right: '55px',
    '@media screen and (max-width: 1546px)': {
      right: '15px',
    },
    '@media screen and (max-width: 1024px)': {
      right: '22px',
    },
    '@media screen and (max-width: 768px)': {
      right: '0',
    },
  },
  containerLoading: {
    padding: '0 10px',
    paddingTop: '60px',
    minHeight: 'calc(100vh - 460px)',
    maxWidth: '1440px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    '@media (max-width: 767px)': {
      padding: '0',
    },
  },
  errorMsg: {
    color: '#cb2d3e !important',
    fontSize: theme.typography.$fzH6,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.67',
  },
  successBlock: {
    marginLeft: '24px',
    marginRight: '24px',
  },
  hide: {
    display: 'none',
  },
}), 'set-up-online-access');

const SetUpOnLineAccess = () => {
  const { slug } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formRedux] = useState(
    useSelector((state) => state.form),
  );

  const [dynamicContent] = useState(formRedux.form && formRedux.form.dynamicContent);

  // const goToVerificationPage = () => history.push('/set-up-online/verification');
  // const goToLinkExpiredPage = () => history.push('/set-up-online/link-expired');
  const goToVarifiedErrorPage = () => history.push('/set-up-online/verified-error');
  const goToOnlineTradingPage = () => history.push('/set-up-online/online-trading-setup');
  const goToDigitalBankPage = () => history.push('/set-up-online/digital-banking-setup');
  const goToDigitalBankReadyPage = () => history.push('/set-up-online/account-is-ready-digital-banking');
  const goToReadyBothPage = () => history.push('/set-up-online/account-is-ready-both');
  const goToSetupBothPage = () => history.push('/set-up-online/already-setup-both');
  const goToOnlineTradingCompletedPage = () => history.push('/set-up-online/account-is-ready-online-trading');
  const goToHasCompletedPage = () => history.push('/set-up-online/has');
  const goToHaveCompletedPage = () => history.push('/set-up-online/have');
  const goToSystemErrorPage = () => history.push('/set-up-online/error');

  const showLoading = (value) => {
    setLoading(value);
  };

  const classes = useStyles();
  const setup_success_dada = dynamicContent && dynamicContent.setup_success_dada || {}
  const successData = {
    logo: successLogo,
    // title: "Your username and password setup is complete",
    // desc: "You may proceed to log in to your iOCBC trading account",
    pt: 'ptSuccess',
    btnText: "Log in",
    clickAction: () => {
      window.open(process.env.iocbcUrl, "_self");
    },
    ...setup_success_dada
  };
  const validationFailedData = {
    // title: "You have reached the maximum number of attempts",
    // desc: parse(
    //   "Please wait for the Welcome Letter and Pin mailer sent to your mailbox to activate your account. <br /> <p className='mt2'>If you have enquiries, please call our Customer Service at 1800 338 8688.</p>"
    // ),
    logo: failedLogo,
    btnText: "Back to home",
    clickAction: () => {
      window.open(process.env.iocbcHomeUrl, "_self");
    },
    title: dynamicContent?.verified_failed_data?.title || '',
    desc: parse(dynamicContent?.verified_failed_data?.desc || '')
  };

  const errorData = {
    logo: failedLogo,
    btnText: "Back to home",
    clickAction: () => {
      window.open(process.env.iocbcHomeUrl, "_self");
    },
    pt: 'ptSuccess',
    title: dynamicContent?.setup_error_dada?.title || '',
    desc: parse(dynamicContent?.setup_error_dada?.desc || '')
  };

  const SetupOnlineTradingMemo = useMemo(
    () => (
      <SetupOnlineTrading
        classes={classes}
        preventSpecialCharacters={preventSpecialCharacters}
        goToDigitalBankPage={goToDigitalBankPage}
        goToOnlineTradingCompletedPage={goToOnlineTradingCompletedPage}
        goToHasCompletedPage={goToHasCompletedPage}
        goToSystemErrorPage={goToSystemErrorPage}
        saveFormData={saveFormData}
      />
    ),
    [],
  );

  const SetupDigitalBankingMemo = useMemo(
    () => (
      <SetupDigitalBanking
        classes={classes}
        preventSpecialCharacters={preventSpecialCharacters}
        restrictSpecialCharacters={restrictSpecialCharacters}
        goToHasCompletedPage={goToHasCompletedPage}
        goToSystemErrorPage={goToSystemErrorPage}
        goToHaveCompletedPage={goToHaveCompletedPage}
        goToReadyBothPage={goToReadyBothPage}
        goToDigitalBankReadyPage={goToDigitalBankReadyPage}
        saveFormData={saveFormData}
      />
    ),
    [],
  );

  const SetupVerificationMemo = useMemo(
    () => (
      <SetupVerification
        classes={classes}
        goToSystemErrorPage={goToSystemErrorPage}
        goToOnlineTradingPage={goToOnlineTradingPage}
        goToDigitalBankPage={goToDigitalBankPage}
        goToSetupBothPage={goToSetupBothPage}
        goToVarifiedErrorPage={goToVarifiedErrorPage}
        saveFormData={saveFormData}
        showLoading={showLoading}
      />
    ),
    [],
  );

  const statusSlug = ['account-is-ready-online-trading', 'verified-error', 'error']

  return (
    <div>
      <Header
        namePage="Trading Account Application"
        backLink={{ name: 'Back to OCBC.com', href: '/' }}
      />

      <Container className={clsx(statusSlug.includes(slug) ? classes.p0: '', classes.container, classes.widthMed3)}>
        {
          slug === 'account-is-ready-both' && <AccessSetupMsg dynamicContent={dynamicContent && dynamicContent.already_both_setup_page} hasInbButton hasOsplButton hasIcon />
        }
        {
          // slug === 'account-is-ready-online-trading' && <AccessSetupMsg dynamicContent={dynamicContent && dynamicContent.already_ospl_setup_page} hasInbButton={false} hasOsplButton hasIcon />

          slug === 'account-is-ready-online-trading' && <StatusMsg data={successData} />
        }
        {
          slug === 'account-is-ready-digital-banking' && <AccessSetupMsg dynamicContent={dynamicContent && dynamicContent.already_inb_setup_page} hasInbButton hasOsplButton={false} hasIcon />
        }
        {
          slug === 'already-setup-both' && <AccessSetupMsg dynamicContent={dynamicContent && dynamicContent.existing_both_setup_page} hasInbButton hasOsplButton />
        }
        {
          slug === 'already-setup-online-trading' && <AccessSetupMsg dynamicContent={dynamicContent && dynamicContent.existing_ospl_setup_page} hasInbButton={false} hasOsplButton />
        }
        {
          slug === 'link-expired' && <DynamicMessage text={dynamicContent && dynamicContent.link_expired_page} classes={classes} />
        }
        {
          slug === 'verified-error' && <StatusMsg data={validationFailedData} />
        }
        {
          (slug === 'verification') && SetupVerificationMemo
        }
        {
          slug === 'online-trading-setup' && SetupOnlineTradingMemo
        }
        {
          slug === 'digital-banking-setup' && SetupDigitalBankingMemo
        }
        {
          slug === 'error' && <StatusMsg data={errorData} />
        }
        {
          (slug === 'has' || slug === 'have') && <DynamicMessage text={dynamicContent && dynamicContent.completed_page} classes={classes} isSingle={slug} />
          // (slug === 'has' || slug === 'have') && <CompletedMsg isSingle={slug} />
        }
        {
          (!slug || loading) && (
            <>
              <div className={classes.containerLoading}>
                <Loading />
              </div>
            </>
          )
        }
        {/* only demo  */}
        {/* <SetUpOnLineDemo
          setDigitalBanking={() => {}}
          setOnlineTrading={() => {}}
        /> */}
      </Container>
      <Footer />
    </div>
  );
};

export default SetUpOnLineAccess;
